module.exports = __webpack_public_path__ + "static/logo-178ddf4a36afe45ff2e68a75e60f3663.png";